(ns frontend.view.modals.fund-edit.events
  (:require [clojure.string :as string]
            [frontend.state.current-session :as session]
            [frontend.view.modals.components.processing-modal :as processing-modal]
            [frontend.actions.entity :as entity-actions]))

(defn form-ready? [state]
  (let [fund-name (:fund/name @state)]
    (not (string/blank? fund-name))))

(defn save! [state close!]
  (processing-modal/start-processing! state)
  (let [data (cond-> (select-keys @state (concat [:fund/teams :fund/name :fund/feeder-fund-to :fund/lux-fund?]
                                                 (when (session/has-feature-access? :feature/lp-reporting)
                                                   [:fund/reporting-admins])
                                                 (when (session/has-feature-access? :feature/transaction-process)
                                                   [:fund/transaction-process-config])))
               (and (session/has-feature-access? :feature/transaction-process)
                    (map? (:fund/transaction-process-config @state)))
               (update :fund/transaction-process-config pr-str))]
    (-> (entity-actions/*->entity-update! (:db/id @state)
                                          data
                                          (fn []
                                            (processing-modal/success! state)
                                            (when close!
                                              (close!)))
                                          (fn []
                                            (partial processing-modal/error! state))))))
